export default __webpack_public_path__ + "static/media/Employers.00c9afcf.svg";